import React, { Component } from "react";
import { Link } from "gatsby";
import "./index.css";

class FooterAppBar extends Component {
  isActive = ({ isCurrent }) => {
    return isCurrent ? { style: { filter: "var(--active-appbar)" } } : null;
  };

  render() {
    return (
      <section
        id="Footer-App-Bar"
        className="fixed-bottom"
        style={{ backgroundColor: "var(--appbar-bg)" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <Link
              getProps={this.isActive}
              to="/market"
              className="col-2 text-center app-bar-link p-0"
              style={{ color: "var(--appbar-text)" }}
            >
              <img
                src={require("../../../src/assets/app-bar/market.svg")}
                alt="Market"
              />
              <br />
              <span>Market</span>
            </Link>
            <Link
              getProps={this.isActive}
              to="/social"
              className="col-2 text-center app-bar-link p-0"
              style={{ color: "var(--appbar-text)" }}
            >
              <img
                src={require("../../../src/assets/app-bar/social-icon.svg")}
                alt="Social"
              />
              <br />
              <span>Social</span>
            </Link>
            <Link
              getProps={this.isActive}
              to="/news"
              className="col-2 text-center app-bar-link p-0"
              style={{ color: "var(--appbar-text)" }}
            >
              <img
                src={require("../../../src/assets/app-bar/news.svg")}
                alt="News"
              />
              <br />
              <span>News</span>
            </Link>
            <Link
              getProps={this.isActive}
              to="/tutorials"
              className="col-2 text-center app-bar-link p-0"
              style={{ color: "var(--appbar-text)" }}
            >
              <img
                src={require("../../../src/assets/app-bar/tutorials.svg")}
                alt="Tutorials"
              />
              <br />
              <span>Tutorials</span>
            </Link>
            <Link
              getProps={this.isActive}
              to="/apps"
              className="col-2 text-center app-bar-link p-0"
              style={{ color: "var(--appbar-text)" }}
            >
              <img
                src={require("../../../src/assets/app-bar/apps.svg")}
                alt="Apps"
              />
              <br />
              <span>Apps</span>
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

export default FooterAppBar;
